import React, { useEffect, useRef, useState } from 'react'
import logo from '../../assets/logo.png';
import footerlogo from '../../assets/footer-image.png';
import Product1 from '../../assets/ProductInformation1.png';
import Product2 from '../../assets/ProductInformation2.png';
import Product3 from '../../assets/ProductInformation3.png';
import NewHeader from '../Neweheader';
import rebon from "../../assets/rebon.png"
import PowerlineForm from '../powerline/PowerlineForm';
import people from "../../assets/peoples.jpg";
import playicon from "../../assets/video-icon.png";
import kingnew from "../../assets/King.png";
import VideoGirl from "../../assets/VideoGirl.svg";
import WilliamImge2 from "../../assets/william-background2.png";
import VideoMen from "../../assets/VideoMen-1.svg";
import bannerimg from "../../assets/Longevitybanner.png";
import grandparents from "../../assets/grandparents.png";
import productlog from "../../assets/productlog.png";
import GSH from "../../assets/GHS.png";
import goldringimg from "../../assets/GoldRing2.png";
import VideoMenb from "../../assets/VideoMen.svg";
import VideoWomen from "../../assets/VideoWomen-1.svg";
import mainplay from "../../assets/mainplay.png";
import VideoPlayer from '../../Common/Components/VideoPlayer';
import Player from '@vimeo/player';
import ENRYGY from "../../assets/images/Energy.png";
import Mist from "../../assets/Mist.png";

import carl from "../../assets/carl.jpg";
import Mary from "../../assets/Mary.jpg";
import toni from "../../assets/toni.jpg";

import micah from "../../assets/micah.jpg";
import Dillard from "../../assets/Dillard.jpg";
import Catherine from "../../assets/Catherine.jpg";
import { useNavigate } from 'react-router-dom';
import { storeAssigned } from '../../services/Methods/normalMethods';
import VisitorList from '../../Common/Components/VisitorComponent';




const Longevity = () => {
    const products = [
        { img: Product1, name: "GSH", desc: "Support Against Oxidative Stress", overlayImg: GSH, pdfFile: "Provizion_GSH" },
        { img: Product2, name: "ENERGY", desc: "Naturally Sustained Energy", overlayImg: ENRYGY, pdfFile: "Provizion_Energy" },
        { img: Product3, name: "MIST", desc: "Energizing Facial Spray", overlayImg: Mist, className: "mist-overlay", pdfFile: "Provizion_KTMist" }
    ];

    const benefits = [
        "Optimize Your Cellular ENERGY Production",
        "Detoxify Your Cells – Even Of Heavy Metals",
        "Decrease Oxidative Cellular Stress - Thereby To Your Organs And Systems",
        "Increase Your Restful and Restorative Sleep",
        "Strengthen Your Immune System - For Optimal Defense",
        "Increase Your Mental Performance And Clarity",
        "Enhance Your Athletic Performance and Exercise Recovery",
        "Revitalize Your Skin and Youthful Appearance"
    ];

    const videos = {
        lonevityProducts: "https://player.vimeo.com/video/1064341084?autoplay=1&autopause=0&controls=true",
        carl: "https://player.vimeo.com/video/1057647659?autoplay=1&autopause=0&controls=true",
        Mary: "https://player.vimeo.com/video/708860860?autoplay=1&autopause=0&controls=true&h=2ea64d32db&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        toni: "https://player.vimeo.com/video/708874586?autoplay=1&autopause=0&controls=true&title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        micah: "https://player.vimeo.com/video/1059289734?autoplay=1&autopause=0&controls=true&title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        Dillard: "https://player.vimeo.com/video/1059290338?autoplay=1&autopause=0&controls=true&title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",

        Catherine: "https://player.vimeo.com/video/708774103?autoplay=1&autopause=0&controls=true&h=f04a93c72e&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"

    };


    const [activeVideo, setActiveVideo] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);
    const navigate = useNavigate();

    const openPopup = (videoKey) => {
        setCurrentVideo(videos[videoKey]);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setCurrentVideo(null);
    };

    const iframeRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        if (isPopupOpen && iframeRef.current) {
            playerRef.current = new Player(iframeRef.current);
            playerRef.current.on('ended', () => setIsPopupOpen(false));
        }

        return () => {
            if (playerRef.current) playerRef.current.off('ended');
        };
    }, [isPopupOpen]);

    const handleDownload = (pdfName) => {
        const link = document.createElement('a');
        const fileUrl = pdfName === 'GSH' ? `/pdf/${pdfName}.pdf` : `/api/Files/documents/${pdfName}.pdf`;

        window.open(fileUrl, '_blank');

        link.href = fileUrl;
        link.download = `${pdfName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };




    return (
        <>
            <section className='bg-[#fff] relative'>
                <img className='absolute top-0 left-0 w-full z-[1] xl:h-[1160px] lg:h-[960px] md:h-[730px] h-[630px] object-cover' src={bannerimg} alt="" />
                <div className='xl:h-[820px] lg:h-[720px] md:h-[600px] h-[520px] container xl:max-w-[1380px] mx-auto px-[15px] relative z-[2]'>
                    <div className="wraper-div flex md:justify-between justify-center h-full flex-wrap">
                        <div className="left pt-[109px] relative lg:left-[150px] md:left-[50px] left-[15px] md:w-auto w-full">
                            <h2 className='font-osw text-[#5E5E5E] xl:text-[90px] xl:leading-[90px] lg:text-[80px] lg:leading-[80px] md:text-[70px] md:leading-[70px] text-[60px] leading-[60px]'>LONGEVITY</h2>
                            <h3 className='font-osw text-[#5E5E5E] xl:text-[60px] xl:leading-[90px] lg:text-[40px] lg:leading-[60px] text-[30px] leading-[40px] md:text-center xl:mt-[30px] mt-[15px]'>PRODUCTS</h3>

                        </div>
                        <div className="right max-w-[620px] mt-auto lg:pb-[250px] pb-[200px] relative md:right-[50px] right-[0px] md:w-auto w-full">
                            <h3 className='xl:text-[40px] xl:leading-[50px] lg:text-[30px] lg:leading-[40px] text-[20px] leading-[30px]  text-[#5E5E5E] text-center font-semibold  '>
                                VIBRANT LONGEVITY FROM VIBRANT HEALTH
                            </h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className='our-goal-sec bg-no-repeat bg-center bg-cover' style={{ backgroundImage: `url(${grandparents})`, backgroundPosition: "center top" }}>

                <div className='xl:h-[987px] lg:h-[800px] h-[500px] container xl:max-w-[1380px] mx-auto px-[15px] relative'>
                    <div class="right-div max-w-[415px] w-full text-center absolute top-[60%] -translate-y-[50%] left-[15px]  italic"><p class="text-[#fff] font-semibold md:text-[30px] md:leading-[36px] text-[25px] leading-[34px]">“Our goal isn’t to live forever in this life, but to create something that might.” </p><p class="font-semibold text-[#fff] md:text-[30px] leading-[30px] text-[25px] mt-[30px]">— Anonymous</p></div>
                </div>
            </section>

            <section className='main_purpose xl:pt-[170px] ld:pt-[100px] pt-[80px] bg-no-repeat bg-center bg-contain' style={{ backgroundImage: `url(${productlog})`, backgroundSize: "1500px", backgroundPosition: "center top" }}>
                <div className='container xl:max-w-[1380px] mx-auto px-[15px]'>
                    <h2 className='relative top-[20px] left-[30px] xl:mb-[70px] mb-[40px] font-osw xl:text-[90px] xl:leading-[80px] lg:text-[80px] lg:leading-[70px] md:text-[50px] md:leading-[40px] text-[40px] leading-[30px] text-[#5E5E5E] text-center    '>LONGEVITY <span className='font-light'>PRODUCTS</span></h2>
                    <div className="mt-[56px] first_box max-w-[1231px] mx-auto bg-[#f2f4fae8]  xl:p-[70px] lg:p-[40px] md:p-[30px] p-[20px] shadow-[3px_3px_16px_#00000029]">
                        <h3 className='text-center xl:text-[40px] xl:leading-[55px] lg:text-[30px] lg:leading-[45px] text-[28px] leading-[40px]  text-[#000000]'>FOR PURE CELLULAR ENERGY</h3>
                        <p className='text-center xl:text-[30px] xl:leading-[40px] lg:text-[25px] lg:leading-[35px] md:text-[25px] md:leading-[35px] text-[18px] leading-[30px] text-[#000] mt-[30px] mb-[30px]'>Provizion’s product line is focused on enhancing your body’s natural energy source – at the cellular level. By increasing each cell’s storehouse of five master molecules of health, most importantly the king of those molecules, Glutathione, Provizion products provide eight powerful benefits for vibrant health and longevity.</p>

                        <div className="list max-w-[910px] mx-auto">
                            <h4 className="mb-[10px] lg:text-[30px] lg:leading-[40px] text-[24px] leading-[30px] text-[#000]">
                                Provizion Product Benefits:
                            </h4>
                            <ul className="xl:ps-[40px] lg:ps-[20px] ps-[15px]">
                                {benefits.map((benefit, index) => (
                                    <li key={index} className="lg:text-[20px] lg:leading-[40px] text-[16px] leading-[30px] font-normal text-[#000]">
                                        {index + 1}. {benefit}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className='box-2 pt-[60px]'>
                        <h2 className='mb-[38px] font-osw font-light lg:text-[47px] text-center lg:leading-[70px] md:text-[40px] md:leading-[60px] text-[30px] leading-[40px]'>PRODUCT INFORMATION</h2>
                        <div className="">
                            <div className="flex flex-col items-center">
                                <div className="flex max-w-[1160px] w-full justify-between xl:flex-nowrap flex-wrap gap-[20px]">
                                    {products.map((product, index) => (
                                        <div key={index} className="text-center lg:w-[calc(100%/3-14px)] md:w-[calc(100%/2-14px)] w-full">
                                            <div className='relative'>
                                                <img className="mx-auto md:min-h-[350px] !min-h-[250px]" src={product.img} alt={product.name} />
                                                <img
                                                    className={` ${product.name === 'ENERGY' && 'energy_class'} mx-auto absolute md:bottom-[-22px] sm:bottom-[10px] bottom-[20px] min-h-[260px] md:left-[60px] sm:left-[160px] left-[100px] -translate-x-[50%] ${product.className}`} src={product.overlayImg} alt={product.name} />
                                            </div>
                                            <h4 className="text-[20px] mt-2 font-semibold">{product.name}</h4>
                                            <p>{product.desc}</p>
                                            <button
                                                className="bg-[#7597C4] w-full max-w-[300px] mx-auto text-[24px] tracking-[0.12px] min-h-[51px] mt-[27px] shadow-[3px_3px_8px_#00000029] text-[#fff]"
                                                onClick={() => handleDownload(product.pdfFile)}
                                            >
                                                Download
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='xl:mt-[132px] lg:mt-[100px] md:mt-[80px] mt-[50px]'>
                <div className='container xl:max-w-[1380px] mx-auto px-[15px]'>
                    {activeVideo === "lonevityProducts" ? (
                        <div className="w-full pb-[0%] relative comon_video">
                            <VideoPlayer url={videos.lonevityProducts} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="video relative">

                            <img src={people} alt="people" />
                            <img
                                onClick={() => openPopup("lonevityProducts")}

                                className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer lg:w-[88px] lg:h-[88px] w-[40px] h-[40px]' src={mainplay} alt="" />
                        </div>
                    )}

                </div>
            </section>

            <section className='product-result bg-no-repeat bg-center bg-contain -mt-[170px] pt-[170px]' style={{ backgroundImage: `url(${goldringimg})`, backgroundPosition: "center top", backgroundSize: "1584px" }}>
                <div className='container xl:max-w-[1380px] mx-auto px-[15px]'>
                    <div className="iiner max-w-[1280px] mx-auto">
                        <h2 className='mt-[54px] mb-[37px] font-osw text-center text-[#5E5E5E] xl:text-[60px] xl:leading-[89px] lg:text-[50px] lg:leading-[70px] md:text-[40px] md:leading-[40px] text-[30px] leading-[40px] font-normal'>PROVEN RESULTS</h2>

                        <div className="video_wrapper flex xl:gap-[30px] gap-[20px] flex-wrap">
                            <div className="video-box relative md:w-[calc(100%/2-15px)] w-full">


                                <div className="w-full pb-[0%] relative comon_video">
                                    <img src={carl} alt="people" className='w-full h-full rounded-lg' />
                                    <img onClick={() => openPopup("carl")}
                                        className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer lg:w-[88px] lg:h-[88px] w-[40px] h-[40px]' src={mainplay} alt="" />
                                </div>

                            </div>

                            <div className="video-box relative md:w-[calc(100%/2-15px)] w-full">

                                <div className="w-full pb-[0%] relative comon_video">
                                    <img src={Mary} alt="people" className='w-full h-full rounded-lg' />
                                    <img onClick={() => openPopup("Mary")}
                                        className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer lg:w-[88px] lg:h-[88px] w-[40px] h-[40px]' src={mainplay} alt="" />
                                </div>

                            </div>

                            <div className="video-box relative md:w-[calc(100%/2-15px)] w-full">

                                <div className="w-full pb-[0%] relative comon_video">
                                    <img src={toni} alt="people" className='w-full h-full rounded-lg' />
                                    <img onClick={() => openPopup("toni")}
                                        className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer lg:w-[88px] lg:h-[88px] w-[40px] h-[40px]' src={mainplay} alt="" />
                                </div>
                            </div>

                            <div className="video-box relative md:w-[calc(100%/2-15px)] w-full">
                                <div className="w-full pb-[0%] relative comon_video">
                                    <img src={micah} alt="people" className='w-full h-full rounded-lg' />
                                    <img onClick={() => openPopup("micah")}
                                        className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer lg:w-[88px] lg:h-[88px] w-[40px] h-[40px]' src={mainplay} alt="" />
                                </div>
                            </div>

                            <div className="video-box relative md:w-[calc(100%/2-15px)] w-full">
                                <div className="w-full pb-[0%] relative comon_video">
                                    <img src={Dillard} alt="people" className='w-full h-full rounded-lg' />
                                    <img onClick={() => openPopup("Dillard")}
                                        className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer lg:w-[88px] lg:h-[88px] w-[40px] h-[40px]' src={mainplay} alt="" />
                                </div>
                            </div>
                            <div className="video-box relative md:w-[calc(100%/2-15px)] w-full">
                                <div className="w-full pb-[0%] relative comon_video">
                                    <img src={Catherine} alt="people" className='w-full h-full rounded-lg' />
                                    <img onClick={() => openPopup("Catherine")}
                                        className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer lg:w-[88px] lg:h-[88px] w-[40px] h-[40px]' src={mainplay} alt="" />
                                </div>


                            </div>
                        </div>
                        <p className='xl:mt-[78px] md:mt-[60px] mt-[30px] lg:text-[28px] lg:leading-[40px] md:text-[24px] md:leading-[35px] text-[18px] leading-[30px] text-center  text-[#000000] max-w-[1131px] mx-auto'>The Results described in these testimonials are unique to the individuals and may be achieved through dedication to a healthy diet and regular exercise, in conjunction with Provizion’s dietary supplements. Results may vary.</p>

                    </div>
                </div>
            </section>

            <section className='xl:pt-[100px] lg:pt-[60px] pt-[40px] relative z-[2]'>
                <div className='shadow-[3px_3px_16px_#00000029] bg-[#F2F4FA]'>
                    <div className='container mx-auto px-[15px]'>

                        <div className="mt-[0] first_box mx-auto optional:[0.93%] p-[40px_15px] flex flex-col-reverse md:flex-row">
                            <div className="content">
                                <h3 className="mt-[20px] max-w-[726px] mx-auto md:text-[20px] leading-[30px] text-[18px] text-[#000000]">
                                    <b>GLUTATHIONE: <br /> KING OF THE MASTER MOLECULES OF HEALTH</b> <br />
                                    <span className="text-[16px]">by Dr. Bill Greenman</span>
                                </h3>
                                <p className="lg:mt-[38px] mt-[20px] max-w-[594px] mx-auto text-[18px] leading-[30px] text-[#000000]">
                                    When you join Provizion you will be sent the first 70 pages of <br />
                                    Dr. Bill Greenman’s desk reference book Glutathione:
                                    <b className="block text-[16px]">King Of The Master Molecules Of Health.</b>
                                </p>
                            </div>

                            <div className="img px-[50px]">
                                <img className="mx-auto" src={kingnew} alt="king" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container mx-auto chosse-legecy-section flex pt-[40px] 2xl:z-[1] z-[3] relative lg:flex-nowrap flex-wrap'>
                    <div className='choose-legacy-heading text-center xl:w-[60%] lg:w-[50%] w-full'>
                        <h2 className='lg:text-right text-center lg:pr-[100px] pr-0 lg:mb-0 mb-[30px] font-osw xl:text-[50px] xl:leading-[90px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[40px] text-[30px] leading-[40px]'>Choose your legacy</h2>
                    </div>
                    <div className='visitors-section xl:pt-[90px] lg:pt-[0px] xl:pl-[50px] pl-[15px] xl:w-[40%] lg:w-[50%] w-full'>
                        <VisitorList />
                    </div>
                </div>
                <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]" onClick={() => window.open(`/api/Files/documents/LegcyLine_Overview_text.pdf`, '_blank')}>LEGACY OVERVIEW</button>
                </div>
                <div className='img 2xl:z-[2] z-[1] relative'>
                    <img className="mx-auto relative 2xl:-top-[815px] xl:-top-[720px] -top-[0px]" src={rebon} alt="king" />
                </div>
            </section>

            <section className='lg:p-[130px_0_137px] p-[100px_0_50px]  bg-no-repeat bg-center bg-cover relative xl:-mt-[500px] lg:-mt-[100px] -mt-[80px] z-[99]' style={{ backgroundImage: `url(${WilliamImge2})`, backgroundSize: "1530px", backgroundPosition: "center top" }}>
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:gap-8 gap-3 px-[15px]">

                    <div className="border p-6 bg-white flex flex-col items-center">
                        {/* <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                                                                <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                                 </div>
                                                 <div className="btn-wrapper flex justify-center xl:gap-[100px] lg:gap-[50px] gap-[20px] md:flex-nowrap flex-wrap">
                                                                <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                                 </div> */}
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/retail_signup`}>
                                BECOME A RETAIL CUSTOMER
                            </button>
                            <img src="/Images/retailcustomer.jpg" alt="Retail Customer" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li className="font-semibold">Purchase Provizion products whenever you wish, from your store within this website</li>
                                <li>Access to Purpose International’s samples, discounted materials, and courses.</li>
                                <li>Access to samples and discounts on Dr. Greenman’s desk reference book on Glutathione.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border p-6 bg-white flex flex-col items-center">
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/business_owner`}>
                                BECOME A WHOLESALE AFFILIATE
                            </button>
                            <img src="/Images/wholesale.jpg" alt="Wholesale Affiliate" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li>New Affiliates who were sponsored by Affiliates above you will be placed into your LegacyLine Team.</li>
                                <li>Sponsor New Affiliates and Retail Customers of your own.</li>
                                <li>Purchase Provizion products when you wish, from the back-office area of your Affiliate website.</li>
                                <li>Sell products to anyone at Retail pricing and keep the profit.</li>
                                <li>Receive Commissions, Bonuses, and Rewards.</li>
                                <li>Access to all Affiliate personal and business training materials.</li>
                            </ul>
                        </div>
                    </div>
                </div>


                {/* <div className='overlay absolute top-[90px] left-0 w-full h-[calc(100%-150px)] bg-[#F6F7FB] opacity-[0.57] z-[1]'></div>
                                                    <div className='container xl:max-w-[1380px] mx-auto px-[15px] relative z-[2]'>
                                                        <div className="title">
                                                            <h2 className="font-osw text-[#000000] xl:text-[70px] lg:text-[60px] md:text-[50px] text-[30px] font-normal text-center font-osw xl:leading-[104px] lg:leading-[70x] mg:leading-[60x] leading-[40x]">YOUR LEGACY IS WAITING FOR YOU</h2>
                                                            <h3 className='xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center md:mt-[27px] mt-[18px] md:mb-[25px] mb-[18px]     '>And We’ll Help Create It </h3>
                                                            <h3 className='xl:mb-[37px] mb-[25px] xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center'>INSTANT ACCESS</h3>
                                                        </div>
                                    
                                                        <div className="form">
                                                            <PowerlineForm />
                                                        </div>
                                                        <p className=
                                                        
                                                        'xl:text-[24px] lg:text-[20px] text-[18px] mx-auto pt-[46px] text-center leading-[30px] text-[#000] max-w-[640px]'>We will immediately email your digital copy of Dr. Greenman’s highly acclaimed book, <b className='italic'>Absolute Certainty.</b></p>
                                                    </div> */}


                <div className="bg-[#f3f4f6f2] container max-w-6xl mx-auto mt-[40px]">
                    <div className="xl:p-[40px] md:p-[20px] p-[25px_15px]">
                        <h2 className="font-osw xl:text-[40px] lg:text-[35px] text-[30px] leading-[1.2] text-center xl:mb-12 mb-4">
                            AFFILIATE AMENITIES
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">

                            <div>
                                <ul className="text-black text-lg">
                                    {[
                                        { title: "LegacyLine", desc: "position and invitation link" },
                                        { title: "Quality of Life", desc: "chart for tracking health/longevity" },
                                        { title: "Personal Affiliate", desc: "website" },
                                    ].map((item, index) => (
                                        <li key={index} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                <strong>{item.title}</strong> {item.desc}
                                            </span>
                                        </li>
                                    ))}

                                    <li className="flex items-start gap-3">
                                        <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                        <div>
                                            <strong>TeamProvizion.com</strong>
                                            <ul className="list-disc pl-6 mt-2 text-base space-y-1">
                                                <li>Personal Purpose Materials</li>
                                                <li>LegacyLine Training</li>
                                                <li><strong>Media Library</strong> of approved marketing tools</li>
                                                <li>Graphics</li>
                                                <li>Product fliers</li>
                                                <li>Videos</li>
                                                <li>Pop up banners</li>
                                                <li>and More!</li>
                                            </ul>
                                        </div>
                                    </li>

                                    {[
                                        { title: "Access", desc: "Your Kingdom Purpose Blueprint - Module 1: our faith-based video series" },
                                        { title: "Access chapters 1-4 of", desc: "Master Keys Of Life: our standard life course materials" },
                                        { title: "Access 70 pages of", desc: "Glutathione: King of The Master: Molecules of Health, Dr. Bill Greenman's book" },
                                        { title: "Access", desc: "The Legacy Podcast – weekly interviews, product and business building insights" },
                                    ].map((item, index) => (
                                        <li key={`access-${index}`} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                {item.title} <strong>{item.desc}</strong>
                                            </span>
                                        </li>
                                    ))}

                                </ul>
                            </div>

                            <div className="flex justify-center relative">
                                <div className="flex flex-col items-center space-y-6">
                                    <img
                                        src="/Images/books.png"
                                        alt="Blueprint"
                                        className="w-100"
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </section>
            {isPopupOpen && (
                <div className="video-popup-overlay">
                    <div className="video-popup-content">
                        <button className="close-button" onClick={() => setIsPopupOpen(false)}>
                            &times;
                        </button>
                        <iframe
                            src={currentVideo}
                            ref={iframeRef}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded Video"
                            className="video-iframe"
                        ></iframe>
                    </div>
                </div>
            )}

            <style>
                {`
                    .mist-overlay {
                        height: 180px !important;
                    }
                `}
            </style>
        </>
    )
}

export default Longevity